import Url from './Url.js'
import Vue from 'vue'
import Res from 'vue-resource';

Vue.use(Res);

var TicketActions = {
  login: {method: 'POST', url: Url.baseUrl+ '/login'},

  loginWithSessionId: {method: 'GET', url: Url.baseUrl + '/login{/sessionId}'},

  loginWithAuthorization: {method: 'GET', url: Url.baseUrl + '/auth{/authorization}'},

  findAllVehicles: {method: 'GET', url: Url.baseUrl + '/vehicles'},

  findAllIssueTypes: {method: 'GET', url: Url.baseUrl + '/issueTypes'},

  createTickets: {method: 'POST', url: Url.baseUrl + '/createTickets'},

  createInternalTickets: {method: 'POST', url: Url.baseUrl + '/internal/createTickets'},

  searchTickets: {method: 'POST', url: Url.baseUrl +  '/search'},

  exportTickets: {method: 'POST', url: Url.baseUrl +  '/export'},

  findTicketsSituations: {method: 'GET', url: Url.baseUrl +  '/situation'},

  findVehiclesByPlate: {method: 'GET', url: Url.baseUrl + '/vehicles/search{/plate}'},

  isPlatesInTickets: {method: 'POST', url: Url.baseUrl + '/isPlatesInTickets'},

  findAllCustomers: {method: 'GET', url: Url.baseUrl + '/customer'},

  putOrganization: {method: 'GET', url: Url.baseUrl + '/customer{/organizationName}'},

  findGeneralStatus: {method: 'GET', url: Url.baseUrl + '/generalStatus'},

  searchOrganizations: {method: 'GET', url: Url.baseUrl +  '/organization/search{/name}'},

  findQuestionsByType: {method: 'GET', url: Url.baseUrl +  '/questions{/type}'},

  findCustomerName: {method: 'GET', url: Url.baseUrl +  '/customer'},

  findLastCoordinate: {method: 'GET', url: Url.baseUrl +  '/transmission/last{/vehicleId}'},

  dueDates: {method: 'GET', url: Url.baseUrl + '/dueDates'}
};

export default Vue.resource('', {}, TicketActions);



// WEBPACK FOOTER //
// ./src/resources/TicketsResource.js